import { useMutation, useQueryClient } from 'react-query';
import axios from 'axios';

const useDeleteImage = () => {
  const queryClient = useQueryClient();
  const { mutate } = useMutation(
    async (imageId) => {
      return axios.delete(`/images/${imageId}`, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
    },
    {
      onSuccess: (res, imageId) => {
        queryClient.invalidateQueries(['images', { imageId: imageId }], { exact: true });
        console.log(`Image with id ${imageId} deleted!`); // TODO
      },
      onError: (err, imageId) => {
        console.log(`Error deleting image with id ${imageId}`); // TODO
      },
    }
  );

  const deleteImage = (imageId, options) => {
    mutate(imageId, options);
  };

  return {
    deleteImage,
  };
};

export default useDeleteImage;
